import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Redirect} from 'react-router-dom';

import Table from '../UI/Table/Table';
import Button from '../UI/Button/Button';
import Blank from '../../hoc/Blank/Blank';
import classes from './DeliveryProgress.css';
import ReactInterval from 'react-interval';
import * as actions from '../../store/actions/index';

class DeliveryProgress extends Component {
    state = {
        addDelivery: false
    }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.onGetMulchYear();
    this.props.onGetDeliveryProgress();
  }

  addDelivery = () => {
      this.setState({addDelivery:true});
    
  }

    render() {
        let addDel = null;
        if (this.state.addDelivery) {
            addDel = <Redirect to='addDelivery' />
        }
        if (this.props.deliveryProgress && this.props.mulchYear) {
            let pl = "5px";
            var data = [];
            let i = -1;
            for (let k in this.props.deliveryProgress) {
                let entry = this.props.deliveryProgress[k];
                i = i + 1;
                data.push({
                    oid: entry.status, data: [
                        {
                            value: entry.status,
                            style: { paddingLeft: pl }
                        }
                    ]})

                    if (this.props.mulchYear.sellHardwood) {
                        data[i].data.push(  
                            {
                                value: entry.hardwoodBags,
                                style: { paddingLeft: pl }
                            }
                        )
                    }

                    if (this.props.mulchYear.sellCedar) {
                        data[i].data.push(  
                            {
                                value: entry.cedarBags,
                                style: { paddingLeft: pl }
                            }
                        )
                    }
                    
                    if (this.props.mulchYear.sellBlack) {
                        data[i].data.push(  
                            {
                                value: entry.blackBags,
                                style: { paddingLeft: pl }
                            }
                        )
                    }

                    if (this.props.mulchYear.sellRed) {
                        data[i].data.push(  
                            {
                                value: entry.redBags,
                                style: { paddingLeft: pl }
                            }
                        )
                    }

                    data[i].data.push(
                        {
                            value: entry.hardwoodBags + entry.cedarBags + entry.blackBags + entry.redBags,
                            style: { paddingLeft: pl }
                        }
                    )
            }



            var header = [
                {
                    name: "Status",
                    style: { paddingLeft: pl }
                }
            ]

            if (this.props.mulchYear.sellHardwood) {
                header.push(  
                    {
                        name: "Hardwood",
                        style: { paddingLeft: pl }
                    }
                )
            }

            if (this.props.mulchYear.sellCedar) {
                header.push(  
                    {
                        name: "Cedar",
                        style: { paddingLeft: pl }
                    }
                )
            }

            if (this.props.mulchYear.sellBlack) {
                header.push(  
                    {
                        name: "Black",
                        style: { paddingLeft: pl }
                    }
                )
            }

            if (this.props.mulchYear.sellRed) {
                header.push(  
                    {
                        name: "Red",
                        style: { paddingLeft: pl }
                    }
                )
            }

            header.push(  
                {
                    name: "Total",
                    style: { paddingLeft: pl }
                }
            )

            return (

                <div className={classes.DeliveryProgress}>  
                    {addDel}
                    <ReactInterval timeout={10000} enabled={true}
          callback={() => this.props.onGetDeliveryProgress()} />        
                    <Table header={header} data={data}></Table>
                    <div>
                    <Button 
                    btnType="Success"
                    clicked={this.addDelivery}>Add Delivery</Button> 
                    </div>
                </div>
            );
        }
        else {
            return (<div></div>);
        }
    }

}


const mapStateToProps = state => {
return {
    deliveryProgress: state.orders.deliveryProgress,
    mulchYear: state.orders.mulchYear
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetMulchYear: () => dispatch(actions.getMulchYear()),
    onGetDeliveryProgress: () => dispatch(actions.getDeliveryProgress())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryProgress);


// WEBPACK FOOTER //
// ./src/components/DeliveryProgress/DeliveryProgress.js